import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/Button";
import type { ButtonProps } from "@/components/ui/Button";
import { IconButton } from "@/components/ui/IconButton";
import type { IconButtonProps } from "@/components/ui/IconButton";
import { Plus } from "lucide-react";
import * as React from "react";

// Linear's applied-filter band: its own full-width row below a list toolbar,
// an 8px-radius container on the quaternary fill with 10px padding and a 4px
// gap. Chips wrap onto more lines; `add` follows the chips and `clear` sits at
// the end of the last line. In a wrapping toolbar it always sorts last and
// takes a full row of its own.
/** Use when a list shows its applied filters as a band below its toolbar. */
function FilterBar(t0) {
  const $ = _c(12);
  let add;
  let children;
  let clear;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      add,
      clear,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = add;
    $[2] = children;
    $[3] = clear;
    $[4] = props;
  } else {
    add = $[1];
    children = $[2];
    clear = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== clear) {
    t1 = clear && <div className="ml-auto flex shrink-0">{clear}</div>;
    $[5] = clear;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== add || $[8] !== children || $[9] !== props || $[10] !== t1) {
    t2 = <div role="group" aria-label="Applied filters" data-filter-bar="" className="order-last flex w-full min-w-0 basis-full flex-wrap items-center gap-1 rounded-lg bg-bg-quaternary p-2.5" {...props}>{children}{add}{t1}</div>;
    $[7] = add;
    $[8] = children;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
const FilterBarAdd = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Plus aria-hidden="true" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <IconButton label="Add filter" variant="ghost" size={24} {...props}>{t0}</IconButton>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
FilterBarAdd.displayName = "FilterBarAdd";
const FilterBarClear = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Button variant="ghost" size="sm" type="button" {...props}>Clear</Button>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
FilterBarClear.displayName = "FilterBarClear";
export { FilterBar, FilterBarAdd, FilterBarClear };